module.exports = __webpack_public_path__ + "static/media/c3.57498d23.jpg";